import { gql } from '@apollo/client';
export const FetchEmployeesWithoutContractCountQuery = gql `
    query FetchEmployeesWithoutContractCount($siteId: SiteId!) {
        staffhours {
            contractedhours {
                employeesWithoutContractCount(siteId: $siteId)
            }
        }
    }
`;
